import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface GroupByGroupDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function GroupByGroupDialog({ open, onClose, onConfirm }: GroupByGroupDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="group-by-group-dialog-title"
      aria-describedby="group-by-group-dialog-description"
    >
      <DialogTitle id="group-by-group-dialog-title">Group by group?</DialogTitle>
      <DialogContent>
        <DialogContentText id="group-by-group-dialog-description">
          This will create one cluster for each group and move group member cards into those clusters.
          Cards owned by participants in multiple groups will be duplicated.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained">
          Group cards
        </Button>
      </DialogActions>
    </Dialog>
  );
}
